import img1 from '../../assets/img/shop-shekil1.jpg';
import img2 from '../../assets/img/shop-shekil2.jpg';
import img3 from '../../assets/img/shop-shekil3.jpg';
import img4 from '../../assets/img/shop-shekil4.jpg';
import img5 from '../../assets/img/shop-shekil5.jpg';
import img6 from '../../assets/img/shop-shekil6.jpg';
import img7 from '../../assets/img/shop-shekil7.jpg';
import img8 from '../../assets/img/shop-shekil8.jpg';

const shopProductData = {
    productData:[
        {
            id: 1,
            img: img1,
            title: "modern furniture",
            price: 400
        },
        {
            id: 2,
            img: img2,
            title: "modern furniture",
            price: 550
        },
        {
            id: 3,
            img: img3,
            title: "modern furniture",
            price: 450
        },
        {
            id: 4,
            img: img4,
            title: "modern furniture",
            price: 500
        },
        {
            id: 5,
            img: img5,
            title: "modern furniture",
            price: 480
        },
        {
            id: 6,
            img: img6,
            title: "modern furniture",
            price: 510
        },
        {
            id: 7,
            img: img7,
            title: "modern furniture",
            price: 580
        },
        {
            id: 8,
            img: img8,
            title: "modern furniture",
            price: 600
        },
    ]
}

export default shopProductData